'use client';

import { useEffect, type PropsWithChildren } from 'react';

import { Grid, useMediaQuery, useTheme } from '@mui/material';

import { usePathname, useRouter } from 'next/navigation';

import { Or2Container } from 'Components/layout/Or2Container';

import {
  OR2_PAGE_HEADER_AVATAR_SIZE,
  Or2PageHeader,
} from '@/components/header/Or2PageHeader';
import { HomeTabs } from '@/modules/home/HomeTabs';

import { Icon } from '../../components/menu/Icon';

export const HomeLayout = ({ children }: PropsWithChildren) => {
  const router = useRouter();
  const pathname = usePathname();
  const theme = useTheme();
  const matchesMobile = useMediaQuery(theme.breakpoints.down('md'));

  const title = matchesMobile ? 'Home' : 'News';

  useEffect(() => {
    if (!matchesMobile && pathname === '/more') {
      router.push('/news');
    }
  }, [matchesMobile, router, pathname]);
  return (
    <>
      <Or2Container mainContent={false}>
        <Grid width={'100%'}>
          <Or2PageHeader
            title={title}
            standalone={!matchesMobile}
            iconNode={
              <Icon size={OR2_PAGE_HEADER_AVATAR_SIZE}>chrome_reader_mode</Icon>
            }
          />
          {matchesMobile && <HomeTabs />}
        </Grid>
      </Or2Container>
      <Or2Container>{children}</Or2Container>
    </>
  );
};
